import { Component, effect, inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { Navbar } from './shared/components/navbar/navbar';
import { LanguageService } from './core/services/language-service';
import { ConfirmDialogModule } from '@openng/optimus-ui/confirmdialog';
import { ToastModule } from '@openng/optimus-ui/toast';
import { ConfirmationService } from '@openng/optimus-ui/api';
import { Loader } from './core/components/loader/loader';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, Navbar, ConfirmDialogModule, ToastModule, Loader],
  templateUrl: './app.html',
  styleUrl: './app.scss',
  providers: [ConfirmationService],
})
export class App {
  private languageAccess = inject(LanguageService);
  private document = inject(DOCUMENT);

  constructor() {
    this.languageAccess.initFromBrowser();
    effect(() => {
      this.document.documentElement.lang =
        this.languageAccess.currentLanguage();
    });
  }
}
